<app-loader [isLoading]="isLoading"></app-loader>
<div class="header">
    <div class="top">
        <a routerLink="/home/communication/mailbox/">
            <h3>Buzón /</h3>
            <div class="breadcrumb">
                <mat-icon svgIcon="arrow back"></mat-icon>
                <h2>Añadir consulta</h2>
            </div>
        </a>
    </div>
</div>
<div class="content form">
    <form [formGroup]="mailForm">
        <h4>Título:</h4>
        <mat-form-field appearance="outline" id="title-form-field">
            <input type="text" matInput placeholder="Título" formControlName="title">
            @if (mailForm.get('title')?.invalid && mailForm.get('title')?.touched) {
            <mat-error>
                El título es requerido
            </mat-error>
            }
        </mat-form-field>
        <h4>Contenido:</h4>
        <quill-editor formControlName="observation" [modules]="modules" [styles]="{height: '300px'}"></quill-editor>
        @if (mailForm.get('observation')?.invalid && mailForm.get('observation')?.touched) {
        <div class="error-message">
            El contenido es requerido
        </div>
        }
        <h4>Estado: </h4>
        <mat-form-field appearance="outline">
            <mat-select formControlName="toppings">
                @for (topping of toppingList; track topping) {
                <mat-option [value]="topping">{{topping}}</mat-option>
                }
            </mat-select>
            @if (mailForm.get('toppings')?.invalid && mailForm.get('toppings')?.touched) {
            <mat-error>
                El estado es requerido
            </mat-error>
            }
        </mat-form-field>
        <h4>Tipo: </h4>
        <mat-form-field appearance="outline">
            <mat-select formControlName="type">
                @for (type of typesList; track type) {
                <mat-option [value]="type">{{type}}</mat-option>
                }
            </mat-select>
            @if (mailForm.get('type')?.invalid && mailForm.get('type')?.touched) {
            <mat-error>
                El tipo es requerido
            </mat-error>
            }
        </mat-form-field>
    </form>

    <div class="buttons">
        <button mat-flat-button id="action" (click)="saveChanges()">Guardar
            cambios</button>
        <button mat-flat-button id="cancel" routerLink="/home/communication/mailbox">Cancelar</button>
    </div>

</div>